import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import VersionHistoryItemBase, {
  VersionHistoryItemAvatar,
} from 'notebook/version-history/VersionHistoryItemBase';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {HasAvatar} from 'ui-library/avatar/Avatar';
import {readableTime} from 'util/DateUtil';

export const VERSION_HISTORY_ITEM_FIRST_OPTION = 'Reset to version';
export const VERSION_HISTORY_ITEM_SECOND_OPTION = 'Duplicate from version';

export interface VersionHistoryItemProps {
  versionDatetime: string;
  versionCreator: HasAvatar;
  isSelected: boolean;
  onClick?: () => void;
  resetToVersionOnClick?: () => void;
  duplicateFromVersionOnClick?: () => void;
}

function VersionHistoryItem({
  versionDatetime,
  versionCreator,
  isSelected,
  onClick,
  resetToVersionOnClick,
  duplicateFromVersionOnClick,
}: VersionHistoryItemProps): JSX.Element {
  const firstRow = <span className={css(styles.versionDatetime)}>{readableTime(versionDatetime)}</span>;
  const secondRow = <VersionHistoryItemAvatar user={versionCreator} tooltipText="Authored this version" />;
  return (
    <VersionHistoryItemBase
      rows={[firstRow, secondRow]}
      isSelected={isSelected}
      onClick={onClick}
      firstOption={{
        text: VERSION_HISTORY_ITEM_FIRST_OPTION,
        icon: 'arrow-rotate-left',
        onClick: resetToVersionOnClick,
      }}
      secondOption={{
        text: VERSION_HISTORY_ITEM_SECOND_OPTION,
        icon: 'copy',
        onClick: duplicateFromVersionOnClick,
      }}
    />
  );
}

const styles = StyleSheet.create({
  versionDatetime: {
    fontSize: '15px',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    lineHeight: '16px',
    color: Color.GRAY_900,
  },
});

export default VersionHistoryItem;
